module.exports = __webpack_public_path__ + "img/2-4.484e1160.svg";